/**
 * AuthCallback del frontend-superadmin.
 *
 * Sprint 11 v2 S11-V2-11. Mismo flujo que el portal vecino, paleta dark
 * con acento admin-red. INITIAL_SESSION se procesa en AuthContext.
 */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth/AuthContext';
import { REDIRECT_KEY } from '../lib/auth/ProtectedRoute';

export function AuthCallback() {
  const { status, error } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (status === 'authenticated') {
      const target = sessionStorage.getItem(REDIRECT_KEY) ?? '/';
      sessionStorage.removeItem(REDIRECT_KEY);
      navigate(target, { replace: true });
    } else if (status === 'orphan') {
      navigate('/login', { replace: true });
    }
  }, [status, navigate]);

  return (
    <div className="min-h-screen bg-bg-page flex items-center justify-center p-6">
      <div className="max-w-md w-full bg-bg-card border-2 border-admin-red rounded-lg p-8 text-center">
        {status === 'loading' && (
          <p className="text-text-secondary">Validando tu acceso…</p>
        )}
        {status === 'unauthenticated' && (
          <>
            <p className="text-text-primary mb-4">
              {error ?? 'No pudimos validar el enlace. Puede haber expirado.'}
            </p>
            <button
              type="button"
              onClick={() => navigate('/login', { replace: true })}
              className="bg-admin-red hover:bg-admin-red/85 text-white font-medium py-2 px-4 rounded-sm transition-colors"
            >
              Volver al inicio de sesión
            </button>
          </>
        )}
      </div>
    </div>
  );
}
